import { render, staticRenderFns } from "./AttachFile.vue?vue&type=template&id=41e7f20c&scoped=true"
import script from "./AttachFile.vue?vue&type=script&lang=js"
export * from "./AttachFile.vue?vue&type=script&lang=js"
import style0 from "./AttachFile.vue?vue&type=style&index=0&id=41e7f20c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e7f20c",
  null
  
)

export default component.exports